<ng-container *appTranslate="let t">
  <new-ui-error-page
    errorCode="403"
    [errorMessage]="t('loginDenied.title')"
    [errorDescription]="t('loginDenied.message')"
  >
    <span class="text-orange-700">{{ t("loginDenied.message2") }}</span>
  </new-ui-error-page>
</ng-container>
